import React from "react";
import { CiLight, CiDark } from "react-icons/ci";
import { RxPerson } from "react-icons/rx";
import Cookies from "universal-cookie";
import { FC, useState } from "react";
import UpdateUserDetails from "../useraccount/UpdateUserDetails";
import { useDispatch } from "react-redux";
import { clearProfileData } from "../redux/slices/userSlice";
import { useNavigate } from "react-router-dom";
import { MdArrowDropDown } from "react-icons/md";
import { MdArrowDropUp } from "react-icons/md";

interface HeaderProps {
  toggleTheme;
  userLogedin;
  userType;
  url: string;
  isDarkMode: boolean;
  img: string;
  name: string;
  userdetails;
  menugroups;
  donationHistory;
}

interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const IconWrapper: FC<IconProps> = ({ className, ...props }) => (
  <div className={className}>
    <RxPerson {...props} />
  </div>
);

export const Header = ({
  toggleTheme,
  isDarkMode,
  userLogedin,
  userType,
  url,
  img,
  name,
  userdetails,
  menugroups,
  donationHistory,
}: HeaderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [usermodalopen, setusermodalopen] = useState(false);
  const [showUserCard, setShowUserCard] = useState(false);
  const [isDepartmentsHovered, setIsDepartmentsHovered] = useState(false);
  const [showJRMCard, setShowJRMCard] = useState(false);
  const [showOnlineCard, setShowOnlineCard] = useState(false);

  const handleDropdownToggle = (event) => {
    event.preventDefault();
    setIsDepartmentsHovered(!isDepartmentsHovered);
  };

  const handleNavigation = (event, path) => {
    event.preventDefault();
    window.history.pushState({}, "", path);
    window.dispatchEvent(new PopStateEvent("popstate"));
  };
  const isActive = (path) => window.location.pathname === path;
  const handleDark = () => {
    toggleTheme();
  };
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const handleNavigationadmin = (event, path) => {
    event.preventDefault();
    navigate(path);
  };

  const handleLogout = () => {
    // const cookies = new Cookies();
    // const token = cookies.get("authToken");
    // if (token) {
    //   cookies.remove("authToken", { path: "/" });
    //   window.location.href = "/home";
    // }
    dispatch(clearProfileData());
  };
  const handleUser = () => {
    setusermodalopen(true);
    setIsOpen(false);
  };

  return (
    <header
      className={` ${isDarkMode
          ? "bg-globalBg border-b border-gray-700"
          : "bg-white border-b border-gray-200"
        }`}
    >
      <div
        className={` pl-1 pr-2 mx-auto ${isDarkMode ? "bg-globalBg " : "bg-[#ffff]"
          }`}
      >
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div>
            <a
              href="/home"
              onClick={(event) => handleNavigation(event, "/home")}
              className="flex items-center justify-between"
            >
              <img
                className="w-auto h-14 sm:h-10 md:h-14 lg:h-14"
                src={img}
                alt="Logo"
              />
              <span className="text-transparent bg-clip-text font-extrabold text-[18px] ml-2.5 bg-gradient-to-r from-[#FD6E6A] to-[#FFC600]">
                {name}
              </span>
            </a>
          </div>
          <div className="md:hidden lg:hidden  items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className={`${isDarkMode ? " text-white" : "text-black"}`}
              aria-label="toggle menu"
            >
              {!isOpen ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6 ml-2 "
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 8h16M4 16h16"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6 ml-2 "
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              )}
            </button>
          </div>

          <div
            className={` ${isOpen ? "translate-x-0" : "translate-x-full md:translate-x-0"
              }  
              transform transition-transform duration-300 ease-in-out w-full md:w-auto mt-20 md:mt-0 fixed md:relative top-0 right-0  md:top-auto md:bg-transparent md:h-auto z-50 md:z-auto  ${isOpen
                ? isDarkMode
                  ? "bg-[#2e2e2e] text-[#ffff]"
                  : "bg-[#ffff] text-black"
                : ""
              }`}
          >
            <div className=" flex flex-col  md:flex-row  md:items-center md:space-x-2 md:p-0 ">
              <a
                href="/home"
                onClick={(event) => {
                  setIsOpen(false);
                  handleNavigation(event, "/home");
                }}
                className={` 
                  py-1 px-2 md:px-1 rounded-[4px] font-semibold text-sm ${isActive("/home")
                    ? "bg-blue-500 text-white"
                    : isDarkMode
                      ? "text-white hover:bg-gray-600"
                      : "text-[#495057] hover:bg-gray-200"
                  }`}
              >
                Home
              </a>
              <a
                href="/about"
                onClick={(event) => {
                  setIsOpen(false);
                  handleNavigation(event, "/about");
                }}
                className={` 
               py-1 px-2 md:px-1  rounded-[4px] font-semibold text-sm ${isActive("/about")
                    ? "bg-blue-500 text-white"
                    : isDarkMode
                      ? "text-white hover:bg-gray-600"
                      : "text-[#495057] hover:bg-gray-200"
                  }`}
              >
                About Us
              </a>

              {menugroups?.length > 0 && (
                <div className="flex flex-col md:flex-row md:gap-2">
                  {menugroups.map((item, index) =>
                    item.label === "Departments" ? (
                      <div
                        key={index}
                        className="relative"
                        onMouseEnter={() => setIsDepartmentsHovered(true)}
                      >
                        <a
                          className={`py-1 px-2 md:px-1 rounded-[4px] flex justify-between font-semibold text-sm ${isActive("/seealldepartments")
                              ? "bg-blue-500 text-white"
                              : isDarkMode
                                ? "text-white hover:bg-gray-600"
                                : "text-[#495057] hover:bg-gray-200"
                            }`}
                        >
                          <a
                            href="/seealldepartments"
                            onClick={(event) => {
                              setIsOpen(false);
                              handleNavigation(event, "/seealldepartments");
                            }}
                          >
                            {item.label}
                          </a>

                          {isDepartmentsHovered ? (
                            <MdArrowDropUp
                              className="w-6 h-6"
                              onClick={handleDropdownToggle}
                            />
                          ) : (
                            <MdArrowDropDown
                              className="w-6 h-6"
                              onClick={handleDropdownToggle}
                            />
                          )}
                        </a>
                        {isDepartmentsHovered && (
                          <div
                            className={`md:absolute md:top-12 md:left-0 relative top-0 left-0  p-0 w-auto md:shadow-lg rounded-lg border border-gray-200 ${isDarkMode
                                ? "bg-[#2e2e2e] border-gray-700"
                                : "bg-[#ffff] border-gray-200"
                              }`}
                            onMouseEnter={() => setIsDepartmentsHovered(true)}
                            onMouseLeave={() => setIsDepartmentsHovered(false)}
                          >
                            <p
                              onClick={(event) => {
                                setIsOpen(false);
                                handleNavigation(event, "/jamiaturraza");
                              }}
                              className={`cursor-pointer block px-4 py-2 rounded-md font-semibold hover:bg-blue-400 transition-colors duration-200 whitespace-nowrap ${isDarkMode
                                  ? "text-white hover:bg-gray-600"
                                  : "text-[#495057] hover:bg-gray-200"
                                }`}
                            >
                              Centre of Islamic studies
                            </p>
                            <p
                              onClick={(event) => {
                                setIsOpen(false);
                                handleNavigation(event, "/sharaeecouncilindia");
                              }}
                              className={`cursor-pointer block px-4 py-2 font-semibold rounded-md hover:bg-blue-400 transition-colors duration-200 whitespace-nowrap ${isDarkMode
                                  ? "text-white hover:bg-gray-600"
                                  : "text-[#495057]  hover:bg-gray-200"
                                }`}
                            >
                              The Shar’ee Council of India
                            </p>
                            <div
                              className={`relative ${isDarkMode
                                  ? "bg-[#2e2e2e] border-gray-700"
                                  : "bg-[#ffff]  border-gray-200"
                                }`}
                            >
                              <p
                                className={`relative cursor-pointer px-4 py-2 flex justify-between block font-semibold rounded-md transition-colors duration-200 whitespace-nowrap ${isDarkMode
                                    ? "text-white hover:bg-gray-600"
                                    : "text-[#495057] hover:bg-gray-200"
                                  }`}
                              >
                                <p
                                  onClick={(event) => {
                                    setIsOpen(false);
                                    handleNavigation(
                                      event,
                                      "/jamaterazamustafa"
                                    );
                                  }}
                                >
                                  Jamat Raza-e-Mustafa
                                </p>

                                {showJRMCard ? (
                                  <MdArrowDropUp
                                    className="w-7 h-7"
                                    onClick={() => setShowJRMCard(false)}
                                  />
                                ) : (
                                  <MdArrowDropDown
                                    className="w-7 h-7"
                                    onClick={() => setShowJRMCard(true)}
                                  />
                                )}
                              </p>
                              {showJRMCard && (
                                <div
                                  className={`px-4 rounded-lg cursor-pointer block font-semibold rounded-md transition-colors duration-200 whitespace-nowrap ${isDarkMode
                                      ? "bg-[#2e2e2e] border-gray-700"
                                      : "bg-[#ffff] border-gray-200"
                                    }`}
                                >
                                  <div
                                    className={`font-semibold flex justify-between rounded-md transition-colors pl-5 py-2 ${isDarkMode
                                        ? "text-white bg-[#2e2e2e] hover:bg-gray-600"
                                        : "text-[#495057] bg-[#ffff] hover:bg-gray-200"
                                      }`}
                                  >
                                    online
                                    {showOnlineCard ? (
                                      <MdArrowDropUp
                                        className="w-7 h-7"
                                        onClick={() => setShowOnlineCard(false)}
                                      />
                                    ) : (
                                      <MdArrowDropDown
                                        className="w-7 h-7"
                                        onClick={() => setShowOnlineCard(true)}
                                      />
                                    )}
                                  </div>
                                  {showOnlineCard && (
                                    <div
                                      onClick={(event) => {
                                        setIsOpen(false);
                                        handleNavigation(
                                          event,
                                          "/jrm/online/registration"
                                        );
                                      }}
                                      className={`font-semibold rounded-md transition-colors px-10 py-2 ${isDarkMode
                                          ? "text-white bg-[#2e2e2e] hover:bg-gray-600"
                                          : "text-[#495057] bg-[#ffff] hover:bg-gray-200"
                                        }`}
                                    >
                                      Registration
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                            <p
                              onClick={(event) => {
                                setIsOpen(false);
                                handleNavigation(event, "/sunniduniya");
                              }}
                              className={`cursor-pointer block px-4 py-2 font-semibold rounded-md hover:bg-blue-400 transition-colors duration-200 whitespace-nowrap ${isDarkMode
                                  ? "text-white hover:bg-gray-600"
                                  : "text-[#495057]  hover:bg-gray-200"
                                }`}
                            >
                              Monthly Sunni Duniya
                            </p>
                            <p
                              onClick={(event) => {
                                setIsOpen(false);
                                handleNavigation(event, "/markazidarulifta");
                              }}
                              className={`cursor-pointer block px-4 py-2 font-semibold rounded-md hover:bg-blue-400 transition-colors duration-200 whitespace-nowrap ${isDarkMode
                                  ? "text-white hover:bg-gray-600"
                                  : "text-[#495057]  hover:bg-gray-200"
                                }`}
                            >
                              Markazi Darul Ifta
                            </p>
                          </div>
                        )}
                      </div>
                    ) : (
                      <p
                        key={index}
                        onClick={() => {
                          item.onClick?.();
                          setIsOpen(false);
                        }}
                        className={`cursor-pointer py-1 px-2 md:px-1 rounded-[4px] font-semibold text-sm 
                        ${isActive(item.path)
                            ? "bg-blue-500 text-white"
                            : isDarkMode
                              ? "text-white hover:bg-gray-600"
                              : "text-[#495057] hover:bg-gray-200"
                          }`}
                      >
                        {item.label}
                      </p>
                    )
                  )}
                </div>
              )}

              <a
                href="/contact"
                onClick={(event) => {
                  setIsOpen(false);
                  handleNavigation(event, "/contact");
                }}
                className={` 
                    py-1 px-2 md:px-1  rounded-[4px] font-semibold text-sm ${isActive("/contact")
                    ? "bg-blue-500 text-white"
                    : isDarkMode
                      ? "text-white hover:bg-gray-600"
                      : "text-[#495057] hover:bg-gray-200"
                  }`}
              >
                Contact Us
              </a>

              {userLogedin ? (
                <div>
                  <div
                    className={`p-1  rounded-md md:flex items-center  ${isDarkMode ? "text-white" : "text-black"
                      } hidden `}
                    onMouseEnter={() => setShowUserCard(true)}
                  >
                    <div className="w-6 h-6 flex items-center justify-center">
                      <IconWrapper style={{ width: "50px", height: "20px" }} />
                    </div>
                  </div>

                  {showUserCard && (
                    <div
                      className={`absolute  top-12 right-0 p-2 w-52 shadow-lg rounded-lg border border-gray-200 hidden sm:block ${isDarkMode
                          ? "bg-[#2e2e2e] border-gray-700"
                          : "bg-[#ffff] border-gray-200"
                        }`}
                      onMouseEnter={() => setShowUserCard(true)}
                      onMouseLeave={() => setShowUserCard(false)}
                    >
                      {userdetails?.roleType === 2 && (
                        <p

                          onClick={(event) => {
                            handleNavigationadmin(event, "/admin");
                            event.currentTarget.parentElement.classList.add(
                              "hidden"
                            );

                          }}
                          className={`cursor-pointer block px-2 py-1 rounded-md font-semibold hover:bg-blue-400 transition-colors duration-200 ${isDarkMode
                              ? "text-white hover:bg-gray-600"
                              : "text-[#495057] hover:bg-gray-200"
                            }`}
                        >
                          Admin
                        </p>
                      )}
                      <p
                        onClick={(event) => {
                          handleNavigation(event, "/Education/Fee");
                        }}
                        className={`cursor-pointer block px-2 py-1 font-semibold rounded-md hover:bg-blue-400 transition-colors duration-200 ${isDarkMode
                          ? "text-white hover:bg-gray-600"
                          : "text-[#495057]  hover:bg-gray-200"
                          }`}
                      >
                        Fee
                      </p>
                      <p
                        onClick={(event) => {
                          handleNavigation(event, "/Education/Registration");
                        }}
                        className={`cursor-pointer block px-2 py-1 font-semibold rounded-md hover:bg-blue-400 transition-colors duration-200 ${isDarkMode
                          ? "text-white hover:bg-gray-600"
                          : "text-[#495057]  hover:bg-gray-200"
                          }`}
                      >
                        Registration
                      </p>
                      <p
                        onClick={(event) => {
                          setusermodalopen(true);
                          event.currentTarget.parentElement.classList.add(
                            "hidden"
                          );
                        }}
                        className={`cursor-pointer block px-2 py-1 font-semibold rounded-md hover:bg-blue-400 transition-colors duration-200 ${isDarkMode
                            ? "text-white hover:bg-gray-600"
                            : "text-[#495057]  hover:bg-gray-200"
                          }`}
                      >
                        Update Details
                      </p>
                      {donationHistory?.label && (
                        <p
                          onClick={donationHistory.onClick}
                          className={`cursor-pointer block px-2 py-1 font-semibold rounded-md hover:bg-blue-400 transition-colors duration-200 ${isDarkMode
                              ? "text-white hover:bg-gray-600"
                              : "text-[#495057] hover:bg-gray-200"
                            }`}
                        >
                          {donationHistory.label}
                        </p>
                      )}
                      <p
                        onClick={handleLogout}
                        className={`cursor-pointer block px-2 py-1 font-semibold rounded-md hover:bg-blue-400 transition-colors duration-200 ${isDarkMode
                            ? "text-white hover:bg-gray-600"
                            : "text-[#495057]  hover:bg-gray-200"
                          }`}
                      >
                        Logout
                      </p>
                    </div>
                  )}

                  <div className="sm:hidden">
                    {userdetails?.roleType === 2 && (
                      <p
                        onClick={(event) => {
                          setIsOpen(false);
                          handleNavigation(event, "/admin");
                        }}
                        className={` 
                          py-1 px-2 md:px-1  rounded-[4px] font-semibold text-sm
                          ? "bg-blue-500 text-white"
                          ${isDarkMode
                            ? "text-white hover:bg-gray-600"
                            : "text-[#495057] hover:bg-gray-200"
                          }`}
                      >
                        Admin
                      </p>
                    )}
                    <p
                      onClick={(event) => {
                        handleNavigation(event, "/Education/Fee");
                      }}
                      className={` 
                        py-1 px-2 md:px-1  rounded-[4px] font-semibold text-sm
                        ? "bg-blue-500 text-white"
                        ${isDarkMode
                          ? "text-white hover:bg-gray-600"
                          : "text-[#495057] hover:bg-gray-200"
                        }`}
                    >
                      Fee
                    </p>
                    <p
                      onClick={(event) => {
                        handleNavigation(event, "/Education/Registration");
                      }}
                      className={` 
                        py-1 px-2 md:px-1  rounded-[4px] font-semibold text-sm
                        ? "bg-blue-500 text-white"
                        ${isDarkMode
                          ? "text-white hover:bg-gray-600"
                          : "text-[#495057] hover:bg-gray-200"
                        }`}
                    >
                      Registration
                    </p>
                    <p
                      onClick={handleUser}
                      className={` 
                        py-1 px-2 md:px-1  rounded-[4px] font-semibold text-sm
                        ? "bg-blue-500 text-white"
                        ${isDarkMode
                          ? "text-white hover:bg-gray-600"
                          : "text-[#495057] hover:bg-gray-200"
                        }`}
                    >
                      Update Details
                    </p>
                    {donationHistory?.label && (
                      <p
                        onClick={() => {
                          donationHistory.onClick?.();
                          setIsOpen(false);
                        }}
                        className={` 
                        py-1 px-2 md:px-1  rounded-[4px] font-semibold text-sm
                        ${isActive(donationHistory.path)
                            ? "bg-blue-500 text-white"
                            : isDarkMode
                              ? "text-white hover:bg-gray-600"
                              : "text-[#495057] hover:bg-gray-200"
                          }`}
                      >
                        {donationHistory.label}
                      </p>
                    )}
                    <p
                      onClick={handleLogout}
                      className={` 
                        py-1 px-2 md:px-1  rounded-[4px] font-semibold text-sm
                        ? "bg-blue-500 text-white"
                        ${isDarkMode
                          ? "text-white hover:bg-gray-600"
                          : "text-[#495057] hover:bg-gray-200"
                        }`}
                    >
                      Logout
                    </p>
                  </div>
                </div>
              ) : (
                <a
                  href="/login"
                  onClick={(event) => {
                    setIsOpen(false);
                    handleNavigation(event, "/login");
                  }}
                  className={` 
                    py-1 px-2 md:px-1  rounded-[4px] font-semibold text-sm  ${isActive("/login")
                      ? "bg-blue-500 text-white"
                      : isDarkMode
                        ? "text-white hover:bg-gray-600"
                        : "text-[#495057] hover:bg-gray-200"
                    }`}
                >
                  Login
                </a>
              )}
              <button
                onClick={() => {
                  toggleTheme();
                  setIsOpen(false);
                }}
                className={`  ml-2 lg:px-1 lg:py-1 md:border rounded-[4.5px] transition-transform transform hover:scale-95 duration-300 ${isDarkMode
                    ? "text-white border-yellow-500 "
                    : "text-black border-blue-500"
                  } `}
              >
                {isDarkMode ? (
                  <CiLight size={20} color="yellow" />
                ) : (
                  <CiDark size={20} color="blue" />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <UpdateUserDetails
        usermodalopen={usermodalopen}
        closeusermodal={() => setusermodalopen(false)}
        url={url}
        isDarkMode={isDarkMode}
        userdetails={userdetails}
      />
    </header>
  );
};
